import type { QueryColumnConfigDTO } from "@/orval/model";
import {
  ActivityIcon,
  CalendarDaysIcon,
  CalendarIcon,
  LineChartIcon,
  SettingsIcon,
  TableIcon,
  UserIcon,
  UsersIcon,
} from "lucide-react";
import type { ColumnOption } from "../data-table-filter/core/types";

export function mapQueryColumnConfig(column: QueryColumnConfigDTO) {
  let icon = SettingsIcon;

  if (column.icon === "calendar") {
    icon = CalendarIcon;
  } else if (column.icon === "users") {
    icon = UsersIcon;
  } else if (column.icon === "user") {
    icon = UserIcon;
  } else if (column.icon === "calendar-days") {
    icon = CalendarDaysIcon;
  } else if (column.icon === "line-chart") {
    icon = LineChartIcon;
  } else if (column.icon === "table") {
    icon = TableIcon;
  } else if (column.icon === "activity" || column.icon === "status") {
    icon = ActivityIcon;
  }

  return {
    ...column,
    accessor: () => {},
    icon,
    facetedOptions: new Map(Object.entries(column.facetedOptions)),
    options: column.options as ColumnOption[],
    min: column.min ?? undefined,
    max: column.max ?? undefined,
  };
}
